module.exports = __webpack_public_path__ + "images/f6b01cdfd24f210d4cdf452d040e9e18.svg";